'use strict'
module.exports = function (Yallist) {
  Yallist.prototype[Symbol.iterator] = function* () {
    for (let walker = this.head; walker; walker = walker.next) {
      yield walker.value
    }
  }
}



//////////////////
// WEBPACK FOOTER
// ./~/jsonwebtoken/~/yallist/iterator.js
// module id = 1432
// module chunks = 0